import React from 'react';
import ImageLoader from '../images/ImageLoader';
import Modal from '../modal/Modal';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreLink } from '../link/Link';
import { Button } from 'react-bootstrap';
import moment from 'moment/moment';

var RewardCardModal = function RewardCardModal(props) {
  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      show = props.show,
      hide = props.hide;
  var Image = model.rewardDetailThumbnailImage ? {
    value: {
      src: model.rewardDetailThumbnailImage,
      alt: 'Placeholder Image'
    }
  } : null;
  var info = model.apiDetail || '';

  if (model.couponStatus === 'used') {
    info = model.rewardRedeemedDatetime ? "Redeemed on ".concat(moment(model.rewardRedeemedDatetime).format('MMMM D, YYYY')) : info;
  } else if (model.couponStatus === 'expired') {
    info = model.rewardExpirationDatetime ? "Expired on ".concat(moment(model.rewardExpirationDatetime).format('MMMM D, YYYY')) : info;
  }

  return /*#__PURE__*/React.createElement(Modal, {
    className: 'loyalty-modal loyalty-modal--bonus-reward-card',
    show: show,
    hide: hide,
    hideCloseButton: true,
    backdrop: true
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-reward-card-modal'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-reward-card-modal__image-container'
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    media: Image,
    type: 'product',
    className: "cb-card__image"
  })), /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-reward-card-modal__body-container'
  }, /*#__PURE__*/React.createElement(Text, {
    tag: 'span',
    className: 'cb-bonus-reward-card-modal__body-container__info',
    field: {
      value: info
    }
  }), /*#__PURE__*/React.createElement(Text, {
    tag: 'span',
    className: 'cb-bonus-reward-card-modal__body-container__header',
    field: {
      value: model.rewardDetailHeader || ''
    }
  }), /*#__PURE__*/React.createElement(RichText, {
    field: {
      value: model.rewardRedemptionInstructions
    },
    tag: "span",
    className: 'cb-bonus-reward-card-modal__body-container__copy'
  }), model.couponStatus === 'redeemed' && model.rewardExpirationDatetime && /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-reward-card-modal__body-container__expires-date'
  }, "Expires ".concat(moment(model.rewardExpirationDatetime).format('M/D/YY'))), /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-primary cb-bonus-reward-card-modal__body-container__button",
    onClick: hide
  }, 'Got it'))));
};

export default RewardCardModal;